export default __webpack_public_path__ + "assets/models/dd55ab652e4f29f83c8f137e35deecb6.glb";